import { render, staticRenderFns } from "./nav-animalkind.vue?vue&type=template&id=6214b972&"
import script from "./nav-animalkind.vue?vue&type=script&lang=js&"
export * from "./nav-animalkind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports